import { render, staticRenderFns } from "./studentProfile.vue?vue&type=template&id=2b78fd52&"
import script from "./studentProfile.vue?vue&type=script&lang=js&"
export * from "./studentProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports